<div class="upload-dragger"
    [class.is-disabled]="disabled"
    [class.is-dragover]="dragger"
    (drop)="dropHandle($event)"
    (dragover)="dragoverHandle($event)"
    (dragleave)="dragLeaveHandle($event)">
    <ng-content></ng-content>
</div>